import { render, staticRenderFns } from "./reviewExamina.vue?vue&type=template&id=dfe3a85a"
import script from "./reviewExamina.vue?vue&type=script&lang=js"
export * from "./reviewExamina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfe3a85a')) {
      api.createRecord('dfe3a85a', component.options)
    } else {
      api.reload('dfe3a85a', component.options)
    }
    module.hot.accept("./reviewExamina.vue?vue&type=template&id=dfe3a85a", function () {
      api.rerender('dfe3a85a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brokerManage/components/reviewExamina.vue"
export default component.exports